var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrdersActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85716 3.57156C2.09385 3.57156 2.28573 3.37968 2.28573 3.14299C2.28573 2.9063 2.09385 2.71442 1.85716 2.71442C1.62047 2.71442 1.42859 2.9063 1.42859 3.14299C1.42859 3.37968 1.62047 3.57156 1.85716 3.57156Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85718 3.14294H12.5715",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85716 7.42861C2.09385 7.42861 2.28573 7.23673 2.28573 7.00004C2.28573 6.76335 2.09385 6.57147 1.85716 6.57147C1.62047 6.57147 1.42859 6.76335 1.42859 7.00004C1.42859 7.23673 1.62047 7.42861 1.85716 7.42861Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85718 7.00006H12.5715",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85716 11.2859C2.09385 11.2859 2.28573 11.0939 2.28573 10.8573C2.28573 10.6206 2.09385 10.4287 1.85716 10.4287C1.62047 10.4287 1.42859 10.6206 1.42859 10.8573C1.42859 11.0939 1.62047 11.2859 1.85716 11.2859Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85718 10.8572H12.5715",
    stroke: "#EFFEF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersActive);
export default __webpack_public_path__ + "static/media/orders-active.3a96dd05b703e5dffec4b9d8132944b8.svg";
export { ForwardRef as ReactComponent };